import { useEffect, useState } from 'react';

import { useQuery } from '@tanstack/react-query';

import { detectEnvironment } from '@/utils/detectEnvironment';

interface VersionResponse {
  version: string;
}

const environment = detectEnvironment();

export const useVersionPolling = () => {
  const [hasNewVersion, setHasNewVersion] = useState(false);
  const [initialVersion, setInitialVersion] = useState<string | null>(null);

  const query = useQuery<VersionResponse>({
    queryKey: ['version'],
    queryFn: async () => {
      const res = await fetch('/version.json', { cache: 'no-cache' });
      return res.json();
    },
    refetchOnWindowFocus: false,
    refetchInterval: 10 * 60 * 1000,
    staleTime: 5 * 60 * 1000,
    gcTime: 15 * 60 * 1000,
    enabled: environment !== 'local'
  });

  useEffect(() => {
    if (query.data?.version) {
      if (!initialVersion) {
        setInitialVersion(query.data.version);
      } else if (query.data.version !== initialVersion) {
        setHasNewVersion(true);
      }
    }
  }, [query.data?.version, initialVersion]);

  return {
    hasNewVersion,
    ...query
  };
};
